<template>
  <div>
    <warning-step
        title="Exit without verifying?"
        description="To do this later, you’ll need to start over." />

    <div class="account-verification__step__buttons-container">
      <el-button
          plain
          type="primary"
          class="account-verification__step__button account-verification__step__button-white"
          @click="cancelClose">
        Cancel
      </el-button>

      <el-button
          type="primary"
          class="account-verification__step__button"
          @click="exitFlow">
        Exit the flow
      </el-button>
    </div>
  </div>
</template>

<script>
import WarningStep from "./WarningStep";
export default {
  name: "ExitConfirmation",
  emits: ["exitResponse"],
  components: { WarningStep },
  methods: {
    requestRetry() {
      this.$emit("previousStepRequested", true);
    },
    cancelClose() {
      this.$emit("exitResponse", false);
    },
    exitFlow() {
      this.$emit("exitResponse", true);
    },
  },
};
</script>

<style scoped>
.account-verification__step__buttons-container {
  margin-top: 50px;
}
</style>
